import script from "./newSubgroup.vue?vue&type=script&setup=true&lang=js"
export * from "./newSubgroup.vue?vue&type=script&setup=true&lang=js"

import "./newSubgroup.vue?vue&type=style&index=0&id=7be0adc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7be0adc2"]])

export default __exports__